"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _informationCard = require("./informationCard");

var _informationCard2 = _interopRequireDefault(_informationCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _informationCard2.default;